{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              -10.720370431868133,
              53.838069715043844
            ],
            [
              -11.168767073182721,
              51.341480837224026
            ],
            [
              -4.715716223302849,
              49.38150194404483
            ],
            [
              0.11249326152005779,
              50.41825592322857
            ],
            [
              2.0953620759473495,
              51.273605549809815
            ],
            [
              2.4079525662990307,
              53.04387610390401
            ],
            [
              0.49127156337021916,
              57.148320963909015
            ],
            [
              -0.40592513161706734,
              61.58721035519102
            ],
            [
              -9.922208999421741,
              57.69689299237234
            ],
            [
              -10.720370431868133,
              53.838069715043844
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}